import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";

const STORAGE_KEY = "last-visited-path";
const EXCLUDED_PATHS = new Set(["/", "/login", "/welcome"]);

function readSavedPath(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (!value || !value.startsWith("/") || EXCLUDED_PATHS.has(value)) {
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

function savePath(path: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, path);
  } catch {
    // ignore quota/privacy errors
  }
}

export function useLastVisitedPath() {
  const location = useLocation();
  const navigate = useNavigate();
  const didRestoreRef = useRef(false);

  // 초기 1회: 루트로 진입한 경우 마지막 방문 경로로 복원
  useEffect(() => {
    if (didRestoreRef.current) return;
    didRestoreRef.current = true;
    if (typeof window === "undefined") return;
    if (window.location.pathname !== "/") return;
    const saved = readSavedPath();
    if (saved) {
      void navigate(saved, { replace: true });
    }
  }, [navigate]);

  // 경로 변경 시 저장 (제외 목록은 저장하지 않음)
  useEffect(() => {
    if (EXCLUDED_PATHS.has(location.pathname)) return;
    savePath(location.pathname);
  }, [location.pathname]);
}
